export const GOOGLE_MAPS_API_KEY = 'AIzaSyAqHJqVulndPDwm01GcmuUcXLOkjtSCY9U';
export const BRIGHTCOVE_ACCOUNT_ID = '1130468768001';
export const ENVIRONMENT_CODE = process.env.CLAYTON_ENVIRONMENT;

/**** Host ****/
export const getEnvironmentHost = () => {
  const options = {
    dev: 'https://claytonbuilt-fe.dev.cct-pubweb.com',
    itg: 'https://claytonbuilt-fe.itg.cct-pubweb.com',
    qua: 'https://claytonbuilt-fe.qua.cct-pubweb.com',
    prod: 'https://www.claytonbuilt.com',
    development: 'http://localhost:3000',
    localhost: 'http://localhost:3000',
  };
  return options[ENVIRONMENT_CODE!] || options['prod'];
};

/**** V2 API ****/
export const getApiUrl = (): string => {
  const options = {
    dev: 'https://api-claytonbuilt.dev.cct-pubweb.com/',
    itg: 'https://api-claytonbuilt.itg.cct-pubweb.com/',
    qua: 'https://api-claytonbuilt.qua.cct-pubweb.com/',
    prod: 'https://api.claytonbuilt.com/',
    localhost: 'http://localhost:3001/',
  };

  return options[ENVIRONMENT_CODE!] || options['prod'];
};

/**** Form Configurations ****/
const VALID_ENVIRONMENTS = ['dev', 'itg', 'qua', 'prod', 'localhost'] as const;
type Environment = (typeof VALID_ENVIRONMENTS)[number];

const environment: Environment =
  (process.env.NEXT_PUBLIC_CLAYTON_ENVIRONMENT as Environment) || 'prod';

if (!VALID_ENVIRONMENTS.includes(environment)) {
  console.warn(
    `Invalid environment "${environment}" detected. Falling back to "prod".`
  );
}

interface FormOption {
  apiKey?: string;
  url: Record<Environment, string>;
}

const options: Record<string, FormOption> = {
  contactus: {
    apiKey: '1kCk1GpLTD4nBXpvAmT5wXEuNomnDeCED1wXju7Kigt7spGBD8VT',
    url: {
      dev: 'https://forms-claytonbuilt.itg.cct-pubweb.com/contactus/v2',
      itg: 'https://forms-claytonbuilt.itg.cct-pubweb.com/contactus/v2',
      qua: 'https://forms-claytonbuilt.qua.cct-pubweb.com/contactus/v2',
      prod: 'https://forms.claytonbuilt.com/contactus/v2',
      localhost: 'https://forms-claytonbuilt.itg.cct-pubweb.com/contactus/v2',
    },
  },
  crossmod: {
    apiKey: '2SbfqRrFUP9eAdwYqSdWHlQjwE6JvMaBDm3GuyDuZQB7Hj1ApuxH',
    url: {
      dev: 'https://forms-claytonbuilt.itg.cct-pubweb.com/crossmod/v2',
      itg: 'https://forms-claytonbuilt.itg.cct-pubweb.com/crossmod/v2',
      qua: 'https://forms-claytonbuilt.qua.cct-pubweb.com/crossmod/v2',
      prod: 'https://forms.claytonbuilt.com/crossmod/v2',
      localhost: 'https://forms-claytonbuilt.itg.cct-pubweb.com/crossmod/v2',
    },
  },
  homeowner: {
    url: {
      dev: 'https://dev.cmhinfo.biz/WebServices2/api/leads/cat',
      itg: 'https://api.claytonhomes.itg.cct-pubweb.com/leads/cat',
      qua: 'https://qua.cmhinfo.biz/WebServices/api/leads/cat',
      prod: 'https://api.claytonhomes.com/leads/cat',
      localhost: 'https://api.claytonhomes.itg.cct-pubweb.com/leads/cat',
    },
  },
  openingdoors: {
    apiKey: 'P1dQ9rrTXnYgdZP2zH1D564qrF1ESrQghCy2CJrqA3kwJs2dH3Av',
    url: {
      dev: 'https://forms-claytonhomebuildinggroup.itg.cct-pubweb.com/openingdoors/v2',
      itg: 'https://forms-claytonhomebuildinggroup.itg.cct-pubweb.com/openingdoors/v2',
      qua: 'https://forms-claytonhomebuildinggroup.qua.cct-pubweb.com/openingdoors/v2',
      prod: 'https://forms.claytonhomebuildinggroup.com/openingdoors/v2',
      localhost:
        'https://forms-claytonhomebuildinggroup.itg.cct-pubweb.com/openingdoors/v2',
    },
  },
};

export const getFormEndpoint = (id: keyof typeof options) => {
  const info = options[id];

  if (!info) {
    console.error(`Form type "${id}" not found.`);
    return null;
  }

  return {
    apiKey: info.apiKey,
    url: info.url[environment] || info.url['prod'], // Fallback to 'prod' if environment is invalid
  };
};
